import { render } from "./MijnOverzicht.vue?vue&type=template&id=219a87fd&scoped=true"
import script from "./MijnOverzicht.vue?vue&type=script&lang=js"
export * from "./MijnOverzicht.vue?vue&type=script&lang=js"

import "./MijnOverzicht.vue?vue&type=style&index=0&id=219a87fd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-219a87fd"]])

export default __exports__